import {
  SetStateAction,
  createContext,
  PropsWithChildren,
  useContext,
  useMemo,
  Dispatch,
} from 'react';
import { useAccountContext } from '../account/index';
import { ProductsType } from '../../api/useProductsApi';
import { defaultProductLoanDetails } from './defaultProductLoanDetails';
import { ProductLoanDetails } from './Products';
import { useProducts } from './useProducts';

export type ProductsObjectContextType = {
  productsObject?: ProductsType,
  productLoanDetails: ProductLoanDetails,
  updateProductLoanDetails: (field: string, value: any, disableIncrementUpdateCount?: boolean) => Promise<void>,
  fetchProducts: () => Promise<void>,
  fetchProductLoanDetails: () => Promise<void>,
  setProductsObject: Dispatch<SetStateAction<ProductsType | undefined>>,
  setProductLoanDetails: Dispatch<SetStateAction<ProductLoanDetails>>,
}

const defaultProductsObjectContext: ProductsObjectContextType = {
  productLoanDetails: defaultProductLoanDetails,
  updateProductLoanDetails: async () => {},
  fetchProducts: async () => {},
  fetchProductLoanDetails: async () => {},
  setProductsObject: () => {},
  setProductLoanDetails: () => {},
};
export const ProductsObjectContext = createContext(defaultProductsObjectContext);

export function useProductsContext() {
  return useContext(ProductsObjectContext);
}

export function ProductsProvider({ children }: PropsWithChildren) {
  const {
    id: accountId,
  } = useAccountContext();

  const { productLoanDetails, productsObject, ...functions } = useProducts(accountId);

  const contextValue = useMemo(() => ({
    productsObject,
    productLoanDetails,
    ...functions,
  }), [productsObject, productLoanDetails]);

  return (
    <ProductsObjectContext.Provider value={contextValue}>
      {children}
    </ProductsObjectContext.Provider>
  );
}
